export default "__VITE_ASSET__sypFZ96E__"